import { SET_SELECTED_PRODUCTS, SET_SELECTED_TYPE_KEYS } from "../Actions/ProductDocuments.action"

const STORAGE_KEY = "productDocuments"

// Kept in localStorage the same way the older download page does it, so a visitor who has
// picked a dozen products does not lose them by navigating away and back.
function loadStateFromLocalStorage() {
    try {
        const serializedState = localStorage.getItem(STORAGE_KEY)
        if (serializedState === null) return undefined
        return JSON.parse(serializedState)
    } catch (e) {
        return undefined
    }
}

const initialState = loadStateFromLocalStorage() || {
    selectedProducts: [],
    selectedTypeKeys: [],
}

const persist = (state) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch (e) {
        // A full or disabled storage must not break the page.
    }
    return state
}

export const productDocuments = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case SET_SELECTED_PRODUCTS:
            return persist({ ...state, selectedProducts: payload })
        case SET_SELECTED_TYPE_KEYS:
            return persist({ ...state, selectedTypeKeys: payload })
        default:
            return state
    }
}
